import { useEffect } from "react";
import { maybeFireReminder } from "@/lib/reminders";

// Drives the local evening reminder while the app is open. Renders nothing.
export function ReminderManager() {
  useEffect(() => {
    maybeFireReminder();
    const iv = setInterval(maybeFireReminder, 60000);
    return () => clearInterval(iv);
  }, []);
  return null;
}
